<template>
<div>
    <Header title="课期详情"></Header>
    <p class="class-title">{{dataSources.name}}</p>
    <van-tabs color="#7181EB" title-active-color="#7181EB" v-model="active" @change="requestData">
        <van-tab :title="item.name" v-for="(item,index) in subjects" :key="index">
        </van-tab>
    </van-tabs>
    <div class="scrollerView" :style="{ height: (wrapperHeight- 145) + 'px' }">
        <div class="card">
            <div class="header">
                <img :src="Images.icon_stress" alt="">
                <p>温馨提示</p>
            </div>
            <p>{{dataSources.sign_tips || '请带好身份证、某某用品，签于会场人数较多，请提前规划好 时间和路线题最好提前30分钟到达进行签到。'}}</p>
            <div class="qr-code-wrap flex ccc">
                <div class="pic-wrap qr-img-wrap flex ccc">
                    <img :src="voucherInfo.qrcode" alt="" class="pic-img qr-img" />
                </div>
                <p class="sign-status">{{voucherInfo.is_sign_text || ''}}</p>
            </div>
            <div class="btn flex rcc">
                <img :src="Images.icon_salon_inheritor" alt="">
                <span>咨询顾问：</span>
                <span v-if="service && service.customer_service">{{service.customer_service.name}} {{service.customer_service.mobile}}</span>
                <span v-else>******</span>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Lockr from 'lockr'
import { mapGetters } from "vuex";
import Header from '@/components/Header'
export default {
    /** 组件挂载 */
    components: {
        'Header': Header
    },
    computed: {
        ...mapGetters(["service"]),
        ...mapGetters(["userInfo"]),
    },
    setup() {
        const active = 2;
        const show = false;
        const showPopup = () => {
            show.value = true;
        };
        return {
            active,
            show,
            showPopup,
        };
    },
    /** 数据区 */
    data() {
        return {
            loading: true,
            active: 0,
            show: false,
            wrapperHeight: 0, //屏幕高度 - 脚部
            dataSources: {},
            voucherInfo: {},
            subjects: [],
            // 列表
            page: 0,
            limit: 10,
        };
    },
    /** 挂载后 */
    mounted() {
        this.stage_id = this.$route.query.id
        this.requestDataTab();
        this.wrapperHeight = document.documentElement.clientHeight;
    },
    /** 更新后 */
    updated() {},
    /** 方法 */
    methods: {
        // 请求数据
        async requestDataTab() {
            let url = this.API.my_enroll_subject_detail;
            let params = {
                subject_stage_id: this.stage_id,
                subject_id: ""
            };
            let result = await this.$post(url, params);
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                this.dataSources = result.data.subject_stage_con
                this.subjects = result.data.subjects
                this.loading = false
                this.requestData()
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },

        async requestData() {
            let url = this.API.my_class_voucher;
            let params = {
                subject_stage_id: this.dataSources.subject_stage_id,
                subject_id: this.subjects[this.active].id,
                type: this.Constants.USER_CLASS,
            };
            let result = await this.$post(url, params);
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                this.voucherInfo = result.data.subject_stage_con;
            }
        },

        showPopup() {
            this.show = !this.show
        },
        // 顶部Nav的跳转
        onPressNav(router) {
            this.$router.push({
                path: '/' + router,
                query: {}
            })
        }
    },
};
</script>

<style lang="less" scoped>
.scrollerView {
    position: relative;
    width: 100%;
}

.scroller {
    background: #F8F8F8;
}

.class-title {
    height: 40px;
    padding: 0 15px;
    background: #fff;
    font-size: 15px;
    color: #333;
    line-height: 44px;
    font-weight: 500;
}

.card {
    margin: 15px;
    padding: 15px;
    border-radius: 10px;
    background: #fff;
    box-shadow: 0px 0px 5px 0px rgba(51, 51, 51, 0.10);

    .header {
        margin-bottom: 6px;
        display: flex;
        align-items: center;

        img {
            width: 15px;
            height: 15px;
            margin-right: 10px;
        }

        p {
            font-size: 12px;
            color: #999;
        }
    }

    >p {
        margin-bottom: 40px;
        font-size: 12px;
        color: #999;
    }

    .qr-code-wrap {

        .qr-img-wrap {
            width: 20rem;
            height: 20rem;
            background-image: url('../../assets/icon/icon_qrcode_bg.png');
            background-size: contain;

            img {
                width: 90%;
                height: 90%;
            }
        }

        p {
            padding: 15px 0 20px;
            font-size: 16px;
            color: #333;
        }
    }

    .btn {
        width: 100%;
        height: 50px;
        color: #fff;
        background-size: cover;
        background-image: url('../../assets/img/img_btn_bg1.png');

        img {
            width: 13px;
            height: 17px;
            margin-right: 7px;
        }

        p {
            font-size: 13px;
            color: #fff;
        }
    }
}
</style>
